import React, { Component } from 'react'
import HospitalTable from './table'

export default class Hospital extends Component {
  render() {
    return (
      <div>
        <HospitalTable/>
      </div>
    )
  }
}
